const padTwoDigits = (value) => String(value).padStart(2, "0");

const getTimestampMillis = (value) => {
  if (!value) return 0;
  if (typeof value.toMillis === "function") return value.toMillis();
  if (typeof value.toDate === "function") return value.toDate().getTime();

  const parsedValue = new Date(value).getTime();
  return Number.isNaN(parsedValue) ? 0 : parsedValue;
};

export const getMonthlyProcessSortValue = (processItem = {}) => {
  const monthMatch = String(processItem.month || "").match(/^(\d{4})-(\d{2})$/);

  if (monthMatch) {
    return Date.UTC(Number(monthMatch[1]), Number(monthMatch[2]) - 1, 1);
  }

  const scheduledDate = processItem.startDate || processItem.endDate || processItem.dueDate;
  const scheduledTime = getTimestampMillis(scheduledDate);

  return scheduledTime || getTimestampMillis(processItem.createdAt);
};

export const shiftMonthPeriod = (monthValue = "", offset = 1) => {
  const match = String(monthValue || "").match(/^(\d{4})-(\d{2})$/);

  if (!match) return String(monthValue || "");

  const shiftedDate = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1 + offset, 1));

  return `${shiftedDate.getUTCFullYear()}-${padTwoDigits(shiftedDate.getUTCMonth() + 1)}`;
};

export const shiftIsoDateByMonths = (dateValue = "", offset = 1) => {
  const match = String(dateValue || "").match(/^(\d{4})-(\d{2})-(\d{2})$/);

  if (!match) return String(dateValue || "");

  const sourceYear = Number(match[1]);
  const sourceMonthIndex = Number(match[2]) - 1;
  const sourceDay = Number(match[3]);
  const targetMonthStart = new Date(Date.UTC(sourceYear, sourceMonthIndex + offset, 1));
  const targetYear = targetMonthStart.getUTCFullYear();
  const targetMonthIndex = targetMonthStart.getUTCMonth();
  const lastTargetDay = new Date(Date.UTC(targetYear, targetMonthIndex + 1, 0)).getUTCDate();

  return `${targetYear}-${padTwoDigits(targetMonthIndex + 1)}-${padTwoDigits(Math.min(sourceDay, lastTargetDay))}`;
};

export const createMonthlyProcessCopyDraft = (processItem = {}) => {
  const hasDateRange = processItem.scheduleType === "range" || Boolean(processItem.startDate);
  const sourceOwner = String(processItem.owner || "Atanmamış").trim();
  const safeOwner = sourceOwner.toLocaleUpperCase("tr-TR") === "TAMAMLANDI"
    ? "Atanmamış"
    : sourceOwner;

  return {
    companyName: processItem.companyName || "",
    companyShortName: processItem.companyShortName || processItem.firmaKisaAdi || "",
    title: processItem.title || processItem.templateName || "",
    owner: safeOwner,
    scheduleType: hasDateRange ? "range" : "month",
    month: hasDateRange ? "" : shiftMonthPeriod(processItem.month, 1),
    startDate: hasDateRange ? shiftIsoDateByMonths(processItem.startDate, 1) : "",
    endDate: hasDateRange
      ? shiftIsoDateByMonths(processItem.endDate || processItem.startDate, 1)
      : "",
    autoRepeat: Boolean(processItem.autoRepeat),
    recurrence: {
      frequency: "monthly",
      interval: Math.max(1, Number(processItem.recurrence?.interval) || 1),
      createTiming: "periodEnd"
    }
  };
};

export const createMonthlyProcessCopyTemplate = (processItem = {}, draft = {}) => ({
  id: processItem.templateId || `copied-${processItem.id || "process"}`,
  name: processItem.templateName || processItem.title || draft.title || "Kopyalanan Görev",
  steps: (processItem.steps || []).map((step, index) => ({
    order: step.order || index + 1,
    groupTitle: step.groupTitle || "",
    title: step.title || "",
    isRequired: step.isRequired !== false
  })),
  autoRepeatDefault: Boolean(draft.autoRepeat),
  recurrence: {
    frequency: "monthly",
    interval: Math.max(1, Number(draft.recurrence?.interval) || 1),
    createTiming: "periodEnd"
  }
});
